<template>
  <app-modal
		@close="$emit('close')"
	>
		<app-modal-default @close="$emit('close')">
			<template v-slot:header>
				{{ $ml.get(`Pause subcription`) }}
			</template>
			<template v-slot:content>

				<div class="pause">

          <div class="logo">
            <svg width="134" height="111" viewBox="0 0 134 111" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="20.7107" cy="20.7107" r="20.7107" fill="#DC4E4E"/>
              <circle cx="110.672" cy="99.67" r="8.4137" fill="#F0F0F0"/>
              <path d="M51.5873 61.8111C50.874 61.8111 50.2957 62.3893 50.2957 63.1027V71.1365C50.2957 72.7982 51.6476 74.1502 53.3093 74.1502H56.9868C58.6484 74.1502 60.0004 72.7982 60.0004 71.1365V40.8637C60.0004 39.202 58.6484 37.85 56.9868 37.85H53.3093C51.6476 37.85 50.2957 39.202 50.2957 40.8637V57.9365C50.2957 58.65 50.874 59.2282 51.5873 59.2282C52.3006 59.2282 52.8789 58.65 52.8789 57.9365V40.8637C52.8789 40.6261 53.0721 40.4331 53.3095 40.4331H56.9869C57.2243 40.4331 57.4175 40.6261 57.4175 40.8637V71.1365C57.4175 71.374 57.2243 71.5671 56.9869 71.5671H53.3095C53.0721 71.5671 52.8789 71.374 52.8789 71.1365V63.1027C52.8789 62.3893 52.3006 61.8111 51.5873 61.8111Z" fill="#3B3B3B"/>
              <path d="M72.6904 74.1502C74.3521 74.1502 75.7041 72.7982 75.7041 71.1365V40.8637C75.7041 39.202 74.3521 37.85 72.6904 37.85H69.0132C67.3515 37.85 65.9995 39.202 65.9995 40.8637V71.1365C65.9995 72.7982 67.3515 74.1502 69.0132 74.1502H72.6904ZM68.5825 71.1363V40.8637C68.5825 40.6261 68.7755 40.4331 69.013 40.4331H72.6903C72.9278 40.4331 73.1208 40.6261 73.1208 40.8637V71.1365C73.1208 71.374 72.9278 71.5671 72.6903 71.5671H69.013C68.7756 71.5669 68.5825 71.3739 68.5825 71.1363Z" fill="#3B3B3B"/>
              <path d="M94.1128 24.8872C85.8021 16.5767 74.753 12 63 12C51.2472 12 40.1979 16.5767 31.8872 24.8872C23.5769 33.1979 19 44.247 19 56C19 67.753 23.5769 78.8021 31.8872 87.1128C40.1979 95.4233 51.2472 100 63 100C72.6231 100 81.7627 96.9499 89.4313 91.1797C90.0012 90.7507 90.1155 89.941 89.6867 89.3711C89.2575 88.8011 88.4485 88.6867 87.878 89.1157C80.661 94.5464 72.0583 97.4169 63 97.4169C51.9371 97.4169 41.5364 93.1087 33.7139 85.2863C25.8912 77.4636 21.5831 67.0629 21.5831 56C21.5831 44.9371 25.8912 34.5364 33.7139 26.7139C41.5364 18.8913 51.9371 14.5831 63 14.5831C74.0629 14.5831 84.4636 18.8912 92.2861 26.7137C100.109 34.5364 104.417 44.9369 104.417 55.9998C104.417 61.7375 103.266 67.2915 100.996 72.5079C98.8038 77.5475 95.6736 82.0423 91.693 85.8674C91.1786 86.3617 91.1622 87.1793 91.6565 87.6936C92.1509 88.2078 92.9685 88.2243 93.4827 87.73C97.7108 83.6671 101.036 78.8924 103.365 73.5385C105.777 67.9952 107 62.0943 107 56C107 44.247 102.423 33.1979 94.1128 24.8872Z" fill="#3B3B3B"/>
              <path d="M38.6101 29.7837C38.1057 29.2796 37.2879 29.2796 36.7836 29.7837C29.7809 36.7863 25.9246 46.0969 25.9246 56C25.9246 65.9031 29.7811 75.2136 36.7838 82.2163C43.7863 89.219 53.0968 93.0753 63.0001 93.0753C72.9032 93.0753 82.2138 89.219 89.2163 82.2163C96.2187 75.2136 100.075 65.9031 100.075 56C100.075 46.0969 96.2187 36.7863 89.2161 29.7837C82.8738 23.4416 74.4584 19.6154 65.5199 19.0099C56.6678 18.4097 47.8995 20.9911 40.8304 26.2771C40.2591 26.7043 40.1424 27.5138 40.5695 28.0851C40.9966 28.6564 41.8062 28.7729 42.3773 28.3462C48.952 23.4297 57.1087 21.0296 65.3453 21.5874C73.6603 22.1506 81.4892 25.7101 87.3893 31.6106C100.838 45.0591 100.838 66.9414 87.3893 80.3898C80.8745 86.9045 72.2129 90.4924 62.9997 90.4924C53.7865 90.4924 45.1247 86.9045 38.61 80.3898C25.1614 66.9412 25.1614 45.059 38.61 31.6106C39.1146 31.1058 39.1146 30.2882 38.6101 29.7837Z" fill="#3B3B3B"/>
            </svg>
          </div>

          <date-selector :label="$ml.get('From date')" v-model="form.from"/>
          <date-selector :label="$ml.get('Till date')" v-model="form.till"/>

          <div class="btns">
            <app-btn @click="pause" :loading="loading.pause">
              {{ $ml.get('Pause') }}
            </app-btn>
            <app-btn @click="unpause" :loading="loading.unpause" v-if="was_paused" styling="inline">
              {{ $ml.get('Remove pause') }}
            </app-btn>
          </div>
				</div>

			</template>
		</app-modal-default>
	</app-modal>
</template>

<script>
import { PlansAPI } from '@/api';
import Moment from 'moment';
export default {
  data() {
    const user = this.$store.getters['user/data'];
    return {
      was_paused: user.plan.meta && user.plan.meta.paused_from && user.plan.meta.paused_till,
      form: {

        from: user.plan.meta && user.plan.meta.paused_from 
          ? Moment(user.plan.meta.paused_from).format('DD MMM YYYY') 
          : null,

        till: user.plan.meta && user.plan.meta.paused_till 
          ? Moment(user.plan.meta.paused_till).format('DD MMM YYYY') 
          : null,
      },
      loading: {
        unpause: false,
        pause: false,
      }
    }
  },

  methods: {
    unpause() {
      const init = async () => {
        await PlansAPI.removePause()
        await this.$store.dispatch('user/updateData')
        this.$notify({
          group: 'notices',
          title: 'Pause disabled',
          type: 'success',
        });
        this.$emit('close');
      }
      
      this.loading.unpause = true;
      init().finally(() => {
        this.loading.unpause = false;
      })
    },

    pause() {

      if(!this.form.from || !this.form.till) {
        this.$notify({
          group: 'notices',
          title: 'Enter dates',
          type: 'error',
        });
        return;
      }

      const init = async () => {
        await PlansAPI.setPause(this.form.from, this.form.till)
        await this.$store.dispatch('user/updateData')
        this.$notify({
          group: 'notices',
          title: 'Pause enabled',
          type: 'success',
        });
        this.$emit('close');
      }

      this.loading.pause = true;
      init().finally(() => {
        this.loading.pause = false;
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.pause {

  display: flex;
  align-items: stretch;
  flex-direction: column;

  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .date-selector {
    margin-top: 40px;
  }

  .btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;


    margin-top: 40px;
  }
}

</style>